module.exports = __webpack_public_path__ + "img/1.682ec569.png";